var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"lang-switch"},_vm._l((_vm.langs),function(lang){return _c('li',{key:lang,staticClass:"lang-switch__lang",class:{'lang-switch__lang--hi': _vm.isCurrentLang(lang)},on:{"click":function($event){return _vm.onLangSwitch(lang)}}},[_c('span',{staticClass:"lang-switch__lang__label"},[_vm._v(_vm._s(lang))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }